import { FaroRoutes } from '@grafana/faro-react';
import { AccountPage } from '@pages/User/AccountPage';
import { DesktopAppHelpPage } from '@pages/User/DesktopAppHelpPage';
import { OrganizationsListPage } from '@pages/User/OrganizationsListPage';
import { TrainingAdditionalResourcesPage } from '@pages/User/TrainingPages/TrainingAdditionalResourcesPage';
import { TrainingAgencyPage } from '@pages/User/TrainingPages/TrainingAgencyPage';
import { TrainingEditorProoferPage } from '@pages/User/TrainingPages/TrainingEditorProoferPage';
import { TrainingFolderPage } from '@pages/User/TrainingPages/TrainingFolderPage';
import { TrainingHubPage } from '@pages/User/TrainingPages/TrainingHubPage';
import { TrainingWatchPage } from '@pages/User/TrainingPages/TrainingWatchPage';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { Route, Routes as Switch } from 'react-router-dom';

import { AuthenticatedAppShell } from '../../../AuthenticatedRoutes/components/AppShell';

export const Routes = () => {
  const { me } = useAuthContext();

  if (!me.id) {
    return null;
  }

  return (
    <AuthenticatedAppShell>
      <FaroRoutes routesComponent={Switch}>
        <Route path={routes.accountPage.pattern} element={<AccountPage />} />

        <Route path={routes.desktopAppHelp.pattern} element={<DesktopAppHelpPage />} />

        <Route path={routes.training.pattern} element={<TrainingHubPage />} />
        <Route path={routes.trainingEditorProofer.pattern} element={<TrainingEditorProoferPage />} />
        <Route path={routes.trainingAgency.pattern} element={<TrainingAgencyPage />} />
        <Route path={routes.trainingFolder.pattern} element={<TrainingFolderPage />} />
        <Route path={routes.trainingWatch.pattern} element={<TrainingWatchPage />} />
        <Route path={routes.trainingAdditionalResources.pattern} element={<TrainingAdditionalResourcesPage />} />

        <Route path={routes.organizationsList.pattern} element={<OrganizationsListPage />} />

        <Route path="*" element={<OrganizationsListPage />} />
      </FaroRoutes>
    </AuthenticatedAppShell>
  );
};
